export default __webpack_public_path__ + "static/media/hamburger-icon.11cfd06b.svg";